import {BaseController} from "./BaseController";
import {ApiLanguages} from "../models/api/ApiLanguage";

export class LanguageController extends BaseController {
    get(): Promise<ApiLanguages> {
        return super.get("api/configs");
    }
}